import { Column, Container, Grid, Label, Row, Separator, useAlignments, useScreen } from 'metrix-common3';
import React from 'react';
import { useIntl } from 'react-intl';

import PolicyListItem from './PolicyListItem';

const Results = (props) => {
    const alignments = useAlignments();
    const screen = useScreen();
    const intl = useIntl();

    const policies = props.boundPolicies;

    // Get translated column headers
    const referenceNumberText = intl.formatMessage({ id: 'Policies_Bound.table.referenceNumber' });
    const policyNumberText = intl.formatMessage({ id: 'Policies_Bound.table.policyNumber' });
    const nameText = intl.formatMessage({ id: 'Policies_Bound.table.name' });
    const doingBusinessAsText = intl.formatMessage({ id: 'Policies_Bound.table.doingBusinessAs' });
    const productText = intl.formatMessage({ id: 'Policies_Bound.table.product' });
    const creationDateText = intl.formatMessage({ id: 'Policies_Bound.table.creationDate' });
    const assignedToText = intl.formatMessage({ id: 'Policies_Bound.table.assignedTo' });
    const typeText = intl.formatMessage({ id: 'Policies_Bound.table.type' });

    return (
        <Container>
            <Grid>
                <Row>
                    {!screen?.isMobile && (
                        <Column md={screen?.isTablet ? 2 : 1}>
                            <Label text={referenceNumberText} textAlign={alignments.left} />
                        </Column>
                    )}
                    {screen?.isDesktop && (
                        <Column md={1}>
                            <Label text={policyNumberText} textAlign={alignments.left} />
                        </Column>
                    )}
                    {screen?.isMobile && (
                        <Column xs={5} md={2}>
                            <Label text={doingBusinessAsText} textAlign={alignments.left} />
                        </Column>
                    )}
                    {!screen?.isMobile && (
                        <>
                            <Column md={screen?.isTablet ? 2 : 1}>
                                <Label text={nameText} textAlign={alignments.left} />
                            </Column>
                            <Column md={2}>
                                <Label text={doingBusinessAsText} textAlign={alignments.left} />
                            </Column>
                        </>
                    )}
                    {!screen?.isMobile && (
                        <React.Fragment>
                            <Column md={screen?.isTablet ? 4 : 2}>
                                <Label text={productText} textAlign={alignments.left} />
                            </Column>
                            <Column md={1}>
                                <Label text={creationDateText} textAlign={alignments.left} />
                            </Column>
                        </React.Fragment>
                    )}
                    {screen?.isDesktop && (
                        <Column lg={2}>
                            <Label text={assignedToText} textAlign={alignments.left} />
                        </Column>
                    )}
                    <Column xs={2} md={1} lg={1}>
                        <Label text={typeText} textAlign={alignments.left} />
                    </Column>
                </Row>
                <Row noguttertop>
                    <Column>
                        <Separator solid />
                    </Column>
                </Row>
            </Grid>
            <Grid>
                {policies?.map((policy, index) => {
                    return (
                        <PolicyListItem
                            key={policy.guid ?? index}
                            policy={policy}
                            history={props.history}
                            context={props.context}
                            intl={intl}
                        />
                    );
                })}
            </Grid>
        </Container>
    );
};

export default Results;
